<template>
  <div>
    <div :id="tabsId" :lazy-load="lazyLoad" :query-tab="queryTab"
         class="mb-4 border-b border-gray-200 tabs-panel w-full">
      <ul :class="[alignClass]"
          :data-tabs-toggle="`#${tabContentId}`"
          class="flex flex-wrap -mb-px text-sm font-medium text-center"
          role="tablist">
        <slot name="header"/>
      </ul>
    </div>
    <div :id="tabContentId">
      <slot name="content"/>
    </div>
  </div>
</template>
<script>
import {initTabs} from "@/components/tabs/index";
import {randomStr} from "@/helpers/helpers";

export default {
  name: "Tabs",
  props: {
    lazyLoad: {
      type: Boolean,
      default: false
    },
    queryTab: {
      type: Boolean,
      default: false
    },
    align: {
      type: String,
      default: "left"
    },
  },
  data() {
    return {
      tab: null,
    }
  },
  computed: {
    tabsId() {
      return `tab-${ randomStr() }`
    },
    tabContentId() {
      return `tabContent-${ randomStr() }`
    },
    alignClass() {
      let classes = "";
      if (this.align === "left")
        classes = "justify-start"
      else if (this.align === "center") {
        classes = "justify-center"
      } else if (this.align === "right") {
        classes = "justify-end"
      }

      return classes;
    }
  },
  methods: {
    showTab(id) {
      this.tab.show(`#${ id }`)
    }
  },
  mounted() {
    this.tab = initTabs({lazyLoad: this.lazyLoad, queryTab: this.queryTab, id: this.tabsId});
    // console.log(this.tab)
  },

};

</script>
